// extracted by mini-css-extract-plugin
export default {"title":"BookingSectionTitle_title__srX3B","divider":"BookingSectionTitle_divider__MAX6u","created":"BookingSectionTitle_created__leQzl"};